import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/security/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // Check if user is properly authenticated with valid tokens
  if (authService.isAuthenticated) {
    return true;
  }

  // If we have user data but no access token, the app is probably initializing
  // Allow navigation and let the JWT interceptor handle token refresh
  if (authService.currentUser) {
    return true;
  }

  // No user data at all - redirect to login
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};
